import { create } from 'zustand'

export type Theme = 'dark' | 'light'

const STORAGE_KEY = 'sn.theme'

function readInitial(): Theme {
  if (typeof window === 'undefined') return 'dark'
  const stored = window.localStorage.getItem(STORAGE_KEY)
  if (stored === 'dark' || stored === 'light') return stored
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}

function applyToDom(theme: Theme) {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute('data-theme', theme)
  document.documentElement.style.colorScheme = theme
}

interface ThemeState {
  theme: Theme
  toggle: () => void
  set: (t: Theme) => void
}

export const useTheme = create<ThemeState>((set, get) => {
  const initial = readInitial()
  applyToDom(initial)
  return {
    theme: initial,
    toggle: () => {
      const next: Theme = get().theme === 'dark' ? 'light' : 'dark'
      window.localStorage.setItem(STORAGE_KEY, next)
      applyToDom(next)
      set({ theme: next })
    },
    set: (t) => {
      window.localStorage.setItem(STORAGE_KEY, t)
      applyToDom(t)
      set({ theme: t })
    },
  }
})
